import {
  BarChartOutlined,
  InboxOutlined,
  CalendarOutlined,
  CommentOutlined,
  GiftOutlined,
  KeyOutlined,
  LineChartOutlined,
  MessageOutlined,
  SafetyOutlined,
  SyncOutlined,
} from '@ant-design/icons';

import DashboardIcon from '../../../components/Icons/DashboardIcon';
import ListIcon from '../../../components/Icons/ListIcon';
import ShieldIcon from '../../../components/Icons/ShieldIcon';
import {
  ANALYTICS,
  DASHBOARD,
  FEEDBACK,
  GIFTS,
  INBOX,
  LIMITS,
  PASSKEYS,
  PROFIT,
  SESSIONS,
  RECONCILIATION,
  RISK_CENTER,
  SCHEDULES,
  TRANSACTIONS,
} from '../../../routes/routeConstants';

export interface INavConfig {
  title: string;
  path: string;
  icon: any;
  // What the command menu matches on besides the title.
  keywords?: string;
  // "g" then this key jumps here (shown in the command menu).
  shortcut?: string;
}

export interface INavGroup {
  // No label: the group sits at the top without a heading.
  label?: string;
  items: INavConfig[];
}

// Sidebar sections, grouped by the job an operator is doing (like Mercury's
// and Vercel's sidebars) rather than one long list.
export const navGroups: INavGroup[] = [
  {
    items: [
      { title: 'Inbox', path: INBOX, icon: <InboxOutlined />, keywords: 'todo attention tasks', shortcut: 'i' },
      { title: 'Overview', path: DASHBOARD, icon: <DashboardIcon />, keywords: 'home dashboard', shortcut: 'o' },
      { title: 'Transactions', path: TRANSACTIONS, icon: <ListIcon />, keywords: 'payments purchases', shortcut: 't' },
    ],
  },
  {
    label: 'Payments',
    items: [
      {
        title: 'Scheduled payments',
        path: SCHEDULES,
        icon: <CalendarOutlined />,
        keywords: 'schedules recurring disputes',
        shortcut: 's',
      },
      { title: 'Dash gifts', path: GIFTS, icon: <GiftOutlined />, keywords: 'gifts', shortcut: 'g' },
      { title: 'Limits', path: LIMITS, icon: <SafetyOutlined />, keywords: 'customer caps' },
    ],
  },
  {
    label: 'Safety',
    items: [
      { title: 'Risk Center', path: RISK_CENTER, icon: <ShieldIcon />, keywords: 'alerts fraud', shortcut: 'r' },
      { title: 'Reconciliation', path: RECONCILIATION, icon: <SyncOutlined />, keywords: 'vtpass paystack' },
    ],
  },
  {
    label: 'Insights',
    items: [
      { title: 'Profit', path: PROFIT, icon: <LineChartOutlined />, keywords: 'costs margin revenue', shortcut: 'p' },
      { title: 'Analytics', path: ANALYTICS, icon: <BarChartOutlined />, keywords: 'growth retention' },
      { title: 'Sessions', path: SESSIONS, icon: <MessageOutlined />, keywords: 'whatsapp chats' },
      { title: 'Feedback', path: FEEDBACK, icon: <CommentOutlined />, keywords: 'ratings comments' },
    ],
  },
  {
    label: 'Account',
    items: [{ title: 'Passkeys', path: PASSKEYS, icon: <KeyOutlined />, keywords: 'security recovery codes' }],
  },
];

export const navConfig: INavConfig[] = navGroups.flatMap((group) => group.items);
